import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/Ảnh thẻ.JPG";
import Tilt from "react-parallax-tilt";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
	return (
		<Container fluid className="home-about-section" id="about">
			<Container>
				<Row>
					<Col md={8} className="home-about-description">
						<h1 style={{ fontSize: "2.6em" }}>
							My name is<span className="purple"> Jackson </span>
						</h1>
						<p className="home-about-body">
							Experienced software engineer with over 2 years of expertise in
							delivering impactful software solutions for a diverse range of
							organisations.
							<br />
							<br />
							My enthusiasm for coding and resolving challenges propels me to
							consistently delve into emerging technologies and keep abreast of
							the most recent industry developments.
							<br />
							<br />I eagerly anticipate the opportunity to work collaboratively
							and apply my expertise to projects or teams that prioritise
							creativity, innovation, and high-quality software development.
						</p>
					</Col>
					<Col md={4} className="myAvatar">
						<Tilt>
							<img
								src={myImg}
								className="img-fluid"
								alt="avatar"
								sizes="50%"
								style={{ borderRadius: "50%", height: "350px", width: "auto" }}
							/>
						</Tilt>
					</Col>
				</Row>
				<Row>
					<Col md={12} className="home-about-social">
						<h1>FIND ME ON</h1>
						<p>
							Feel free to <span className="purple">connect </span>with me
						</p>
						<ul className="home-about-social-links">
							<li className="social-icons">
								<a
									href="https://github.com/panhduc1001"
									target="_blank"
									rel="noreferrer"
									className="icon-colour  home-social-icons"
								>
									<AiFillGithub />
								</a>
							</li>
							<li className="social-icons">
								<a
									href="https://www.linkedin.com/in/jackson-anhducphan/"
									target="_blank"
									rel="noreferrer"
									className="icon-colour  home-social-icons"
								>
									<FaLinkedinIn />
								</a>
							</li>
						</ul>
					</Col>
				</Row>
			</Container>
		</Container>
	);
}
export default Home2;
